export { AuthenticatorComponent } from './authenticator.component';
export { AuthenticatorModule } from './authenticator.module';

